// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Avaliacoes_ListResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for GET /avaliacoes/avaliacoes/list.
 *
 * dados is an object with two fields:
 *  - `chats`: the conversations returned by the external msgRepoApi
 *    `conversation/list` endpoint (Message_repo_model::getChatsByPlatformsAndDeviceKeys),
 *    each enriched in the controller with `evaluations`, an `evaluationResults`
 *    map keyed by criterion name, and the per-chat dummy/real evaluation
 *    objects pulled from the external avaliacoesApi. The chat shape is an
 *    opaque third-party passthrough whose nested `infos` block and
 *    dynamic-keyed `evaluationResults` map have no fixed schema.
 *  - `criteria`: the evaluation criteria keyed by criterion ID, identical to
 *    GET /avaliacoes/avaliacoes/listCriteria (Avaliacoes_model::mapIDCriteria()).
 *    Serializes to `[]` when the external service returns nothing.
 */
import type { Avaliacoes_ListCriteriaRow } from './Avaliacoes_ListCriteriaRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Avaliacoes_ListResponseDados {
chats: unknown[]
criteria: Avaliacoes_ListCriteriaRow[]
}

export type Avaliacoes_ListResponse = ApiResponse<Avaliacoes_ListResponseDados>;

registerResponseContract('Avaliacoes_ListResponse', {
  chats:    { type: 'array',   required: true },
  criteria: {
    type: 'array',
    required: true,
    items: {
      ID:   { type: 'number',  required: true },
      name: { type: 'string',  required: true },
    },
  },
})
